import React, {useEffect} from 'react';
import './businessEducation.scss';

import {Footer, Navigation} from "../../components";
import Hero from "./sections/hero/Hero";
import Benefits from "./sections/benefits/Benefits";
import Packages from "./sections/packages/Packages";
import Industries from "./sections/industries/Industries";
import Testimonials from "./sections/testimonials/Testimonials";
import Success from "./sections/success/Success";

const BusinessEducation = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);
    return (
        <div className={'business-education'} id={"business_education"}>
            <div className="business-education_nav">
                <Navigation/>
            </div>
            <Hero/>
            <Success/>
            <Benefits/>
            <Industries/>
            <Packages/>
            <Testimonials/>
            <Footer/>
        </div>
    );
};

export default BusinessEducation;
